import * as actionTypes from "./constants";
import * as phases from "../../utils/helpers/phases";
import {
  removeFromArray,
  updateItemInArray
} from "../../utils/helpers/immutable";
import { SYNC_ROOM_GROUPS_REQUEST } from "../../synchronization/constants";
const initialState = {
  phase: phases.INIT,
  data: []
};
export default (state = initialState, action) => {
  switch (action.type) {
    case SYNC_ROOM_GROUPS_REQUEST:
    case actionTypes.ADD_ROOM_GROUP_REQUEST:
    case actionTypes.EDIT_ROOM_GROUP_REQUEST:
    case actionTypes.REMOVE_ROOM_GROUP_REQUEST:
    case actionTypes.GET_ROOM_GROUPS_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };
    case actionTypes.GET_ROOM_GROUPS_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: action.roomGroups
      };
    case actionTypes.ADD_ROOM_GROUP_REJECT:
    case actionTypes.REMOVE_ROOM_GROUP_REJECT:
    case actionTypes.EDIT_ROOM_GROUP_REJECT:
    case actionTypes.GET_ROOM_GROUPS_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };

    case actionTypes.ADD_ROOM_GROUP_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: state.data.concat(action.roomGroup)
      };

    case actionTypes.EDIT_ROOM_GROUP_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: updateItemInArray(
          state.data.findIndex(
            roomGroup => roomGroup.roomGroupId === action.roomGroup.roomGroupId
          ),
          action.roomGroup,
          state.data
        )
      };

    case actionTypes.REMOVE_ROOM_GROUP_SUCCESS:
      return {
        ...state,
        phase: phases.LOADED,
        data: removeFromArray(
          state.data.findIndex(
            roomGroup => roomGroup.roomGroupId === action.roomGroupId
          ),
          state.data
        )
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/rooms/groups/reducer.js